import { HTTP_METHODS } from "../../Common/modules/DataProvider/constants/DataProvider.constants";
import { customRequest } from "../../Common/modules/DataProvider/utils/DataProvider.utils";
import { IAadhaarKYC } from "../IAadhaarKYC";
import {
  get_redirect_url_polling_api,
  post_initiate_contract,
  refresh_contract,
} from "../constants/AadhaarKYC.apis";

export const initiateKYCContract = ({
  orderUuid,
  returnUrl,
}: IAadhaarKYC.IInitiateKYCContractParams) => {
  try {
    return customRequest<IAadhaarKYC.IInitiateKYCContractResponse>({
      endpoint: post_initiate_contract,
      method: HTTP_METHODS.POST,
      payload: {
        return_url: returnUrl,
        order_uuid: orderUuid,
      },
    });
  } catch (error) {
    console.error("Error in react lib initiateKYCContract", error);
    throw error;
  }
};

export const refreshContract = ({
  orderUuid,
}: IAadhaarKYC.IRefreshKYCContractParams) => {
  try {
    return customRequest<IAadhaarKYC.IRefreshKYCContractParamsResponse>({
      endpoint: refresh_contract,
      method: HTTP_METHODS.POST,
      payload: {
        order_uuid: orderUuid,
      },
    });
  } catch (error) {
    console.error("Error in react lib refreshContract", error);
    throw error;
  }
};

export const refreshKycContract = ({
  orderUuid,
}: IAadhaarKYC.IRefreshKYCContractParams) => {
  try {
    return customRequest<IAadhaarKYC.IRefreshKYCContractParamsResponse>({
      endpoint: refresh_contract,
      method: HTTP_METHODS.POST,
      payload: {
        order_uuid: orderUuid,
      },
    });
  } catch (error) {
    console.error("Error in react lib refreshKycContract", error);
    throw error;
  }
};

/**
 * This function calls the KYC polling API to check the status of KYC verification
 * @param object { asyncTaskId, kycStep } Parameters for polling KYC status
 * @returns A promise containing API response with KYC status, next poll time, and redirect URL
 */
export const callKycPollingApi = ({
  asyncTaskId,
  kycStep,
}: IAadhaarKYC.IAadhaarKYCModal.IKycPollingPayloadProps): Promise<IAadhaarKYC.IAadhaarKYCModal.IKycPollingApiResponse> => {
  try {
    return customRequest({
      endpoint: `${get_redirect_url_polling_api}/${asyncTaskId}?kyc_step=${kycStep}`,
      method: HTTP_METHODS.GET,
    });
  } catch (error) {
    console.error("Error in react lib callKycPollingApi", error);
    throw error;
  }
};

export const pollKycStatus = ({
  asyncTaskId,
  kycStep,
}: IAadhaarKYC.IAadhaarKYCModal.IKycPollingPayloadProps) => {
  try {
    return customRequest<IAadhaarKYC.IAadhaarKYCModal.IKycPollingApiResponse>({
      endpoint: `${get_redirect_url_polling_api}/${asyncTaskId}`,
      method: HTTP_METHODS.GET,
      payload: {
        kyc_step: kycStep,
      },
    });
  } catch (error) {
    console.error("Error in react lib pollKycStatus", error);
    throw error;
  }
};
